<template>
  <div>
    <div v-if="!spinner && this.$store.getters.isBookingLoading" v-center>
      <h2>No hay reservas o no ha seleccionado ningún tipo de listado</h2>
    </div>
    <Loader v-if="spinner" color="#fedd00" />
  </div>
</template>

<script>
import Loader from "vue-spinner/src/ScaleLoader.vue";

export default {
  name: "CustomLoader",
  props: ["width", "heigth",'spinner', 'reservas'],
  components: {
    Loader
  },
  data() {
    return {
      style: {
        width: this.width,
        height: this.height
      },
      color: '#008cfe'
    };
  }
};
</script>